"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CmeterUI;

var _react = _interopRequireDefault(require("react"));

var _IconWrapper = _interopRequireDefault(require("./components/IconWrapper"));

var _Dots = _interopRequireDefault(require("./components/Dots"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CmeterUI(_ref) {
  let {
    icons = [],
    cmeterStatus = [],
    stagesPrefix = 'cmeter--',
    progressIndicator: ProgressIndicator = _Dots.default
  } = _ref;

  const renderStageIcons = () => {
    return cmeterStatus.map((status, statusIndex) => {
      let additionalClassName = "".concat(stagesPrefix).concat(status.stage);
      const providedIcon = icons.find(v => {
        return v.name == status.name;
      }).icon;
      const Icon = providedIcon !== null && providedIcon !== void 0 ? providedIcon : /*#__PURE__*/_react.default.createElement(_IconWrapper.default, null, icons);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "cmeter__stage ".concat(additionalClassName),
        key: "stageIcon-".concat(statusIndex)
      }, !!statusIndex && /*#__PURE__*/_react.default.createElement(ProgressIndicator, null), Icon);
    });
  };

  const renderProgressBar = () => {
    return renderStageIcons();
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "cmeter"
  }, renderProgressBar());
}